(function(){
  var root=document.querySelector('[data-ups-ship-calc]'); if(!root)return;
  var zip=root.querySelector('[name=destZip]'),dateInput=root.querySelector('[name=orderDate]'),out=root.querySelector('[data-ups-calc-output]'),btn=root.querySelector('[data-ups-calc-run]');

  function pad(n){return String(n).padStart(2,'0')}
  function iso(d){return d.getFullYear()+'-'+pad(d.getMonth()+1)+'-'+pad(d.getDate())}
  function localDate(s){var p=s.split('-').map(Number);return new Date(p[0],p[1]-1,p[2],12,0,0)}
  function nthWeekday(year,month,weekday,n){
    var d=new Date(year,month,1,12); var add=(7+weekday-d.getDay())%7; d.setDate(1+add+(n-1)*7); return d;
  }
  function lastWeekday(year,month,weekday){
    var d=new Date(year,month+1,0,12); d.setDate(d.getDate()-((7+d.getDay()-weekday)%7)); return d;
  }
  function upsClosedDates(year){
    // Major 2026-style UPS no-pickup/no-delivery holidays: New Year's, MLK,
    // Memorial, Independence Day, Labor Day, Thanksgiving, Christmas.
    var dates=[
      new Date(year,0,1,12),
      nthWeekday(year,0,1,3),
      lastWeekday(year,4,1),
      new Date(year,6,4,12),
      nthWeekday(year,8,1,1),
      nthWeekday(year,10,4,4),
      new Date(year,11,25,12)
    ];
    return dates.map(iso);
  }
  function isWeekend(d){return d.getDay()===0||d.getDay()===6}
  function isClosed(d){return upsClosedDates(d.getFullYear()).indexOf(iso(d))>=0}
  function isBusinessDay(d){return !isWeekend(d)&&!isClosed(d)}
  function addBusinessDays(start,count){
    var d=new Date(start); var n=0;
    while(n<count){d.setDate(d.getDate()+1);if(isBusinessDay(d))n++}
    return d;
  }
  function isShipDay(d){
    var dow=d.getDay();
    if(!(dow>=1&&dow<=3)||isClosed(d))return false;
    // Live animals should not be tendered immediately before a UPS holiday.
    var arrival=new Date(d);arrival.setDate(arrival.getDate()+1);
    if(isClosed(arrival))return false;
    return true;
  }
  function earliestShip(order){
    var eligible=addBusinessDays(order,3),d=new Date(eligible),guard=0;
    while(!isShipDay(d)&&guard<21){d.setDate(d.getDate()+1);guard++}
    return d;
  }
  function fmt(d){return d.toLocaleDateString('en-US',{weekday:'long',month:'long',day:'numeric',year:'numeric'})}
  function short(d){return d.toLocaleDateString('en-US',{month:'short',day:'numeric'})}

  var today=new Date(); dateInput.value=iso(today);

  btn.addEventListener('click',function(){
    var z=zip.value.trim(),ds=dateInput.value;
    if(!/^\d{5}$/.test(z)){out.innerHTML='<strong>Please enter a valid 5-digit U.S. ZIP code.</strong>';return}
    if(!ds){out.innerHTML='<strong>Please select an order date.</strong>';return}

    var order=localDate(ds),ship=earliestShip(order),arrival=new Date(ship);arrival.setDate(arrival.getDate()+1);
    var regionNote='';
    var zi=Number(z);
    if((zi>=99500&&zi<=99999)||(zi>=96700&&zi<=96899)){
      regionNote='<div class="dd-ups-note"><strong>Destination review required:</strong> Alaska/Hawaii and other non-contiguous destinations require manual next-day-service and live-fish shipping confirmation before an order can be scheduled.</div>';
    }

    out.innerHTML='<div class="dd-ups-result-head"><div><div class="dd-page-kicker">EARLIEST NORMAL-SCHEDULE RESULT</div><h3>'+fmt(ship)+'</h3></div><span class="dd-ups-status">Potential Ship Date</span></div>'+
      '<div class="dd-ups-result-grid">'+
      '<div class="dd-ups-result"><small>Origin</small><strong>Willoughby, OH</strong></div>'+
      '<div class="dd-ups-result"><small>Destination</small><strong>'+z+'</strong></div>'+
      '<div class="dd-ups-result"><small>Potential Ship</small><strong>'+short(ship)+'</strong></div>'+
      '<div class="dd-ups-result"><small>Next-Day Target</small><strong>'+short(arrival)+'</strong></div>'+
      '</div>'+
      '<div class="dd-ups-note">The calculator counts three business days after the order date, then selects the next eligible Monday–Wednesday ship day. It skips major UPS no-service holidays and avoids a ship date immediately before one of those holidays. Fish must also complete quarantine/observation and pass shipping-readiness review.</div>'+regionNote;
  });
})();